export * from './Printable_DiseaseProfile.js';
//# sourceMappingURL=index.js.map